<template>
  <zm-drawer
    ref="zmDrawer"
    :visible="visible"
    :title="title"
    :footer="footer"
    :okText="okText"
    :width="'55%'"
    :placement="placement"
    @cancel="cancel"
    @ok="submitForm"
    class="modal"
    id="drawerExport"
  >
    <div slot="drawerBody">
      <a-spin :spinning="loading">
        <div class="derivedModeImport">
          <a-row>
            <a-col :span="12" class="radioCol">
              <span>导入方式</span>
              <a-radio-group v-model="importType" @change="changeImportType" class="derivedModeRadio">
                <a-radio :value="1">
                  全新导入
                </a-radio>
                <a-radio :value="2">
                  补充导入
                </a-radio>
              </a-radio-group>
            </a-col>
            <a-col :span="12">
              <span class="spanRequired">设备分类</span>
              <a-tree-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                @change="(value, label, extra) => changeEquipmentType(value, label[0])"
                v-model="equipmentTypeImport"
                style="width: 200px;margin-left: 8px;"
                placeholder="请选择设备类型"
                show-search
                :filterTreeNode="filterTreeNode"
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="equipmentClassList"
                :replaceFields="{
                  title: 'name',
                  key: 'code',
                  value: 'code'
                }"
              ></a-tree-select>
            </a-col>
          </a-row>
        </div>
        <div style="position:relative;width: 100%">
          <div class="checkModelBox checkDeviceTypeBox">
            <div class="titleDiv">
              <div class="title">
                <span class="titleName">{{ checkBasicList.name }}</span>
                <a-checkbox class="allCheckBox checkBoxGroupTitle" :disabled="importType === 1" :indeterminate="checkBasicList.indeterminate" :checked="checkBasicList.checkAll" @change="changeAll(checkBasicList, $event)">
                  全选
                </a-checkbox>
              </div>
            </div>
            <div class="checkBoxGroup" >
              <a-checkbox v-for="item2 in checkBasicList.options.children" @change="(e) => chagneBasicCheckBox(checkBasicList, item2,e)" :checked="checkBasicList[importType === 1 ? 'checkList' : 'bcList'].indexOf(item2.name) > -1" :disabled="importType === 1 ? true : item2.disabled" class="importCheckBox">
                <a-tooltip>
                  <template slot="title">
                    {{ item2.name }}
                  </template>
                  <span class="ellipsis">{{ item2.name }}</span>
                </a-tooltip>
              </a-checkbox>
            </div>
          </div>
          <div v-for="(item, index) in checkDeviceTypeList" :key="item.name" class="checkModelBox checkDeviceTypeBox">
            <div class="titleDiv">
              <div class="title">
                <span class="titleName">{{ item.pName }}</span>
                <a-checkbox class="allCheckBox checkBoxGroupTitle" :disabled="importType === 1" :indeterminate="item[importType === 1 ? 'basicIndeterminate' : 'indeterminate']" :checked="item[importType === 1 ? 'basicCheckAll' : 'checkAll']" @change="fixedAllChange('checkDeviceTypeList',index, $event)">
                  全选
                </a-checkbox>
              </div>
            </div>
            <a-checkbox-group class="checkBoxGroup" v-model="item[importType === 1 ? 'basicCheckList' : 'checkList']" :options="item.children" :disabled="importType === 1" @change="fixedOnChange('checkDeviceTypeList',index, $event)">
              <span slot="label" slot-scope="{ name }">
                <a-tooltip>
                  <template slot="title">
                    {{ name }}
                  </template>
                  <span class="ellipsis">{{ name }}</span>
                </a-tooltip>
              </span>
            </a-checkbox-group>
          </div>
          <!--          <div :class="importType === 1 ? 'checkDisable' : ''"></div>-->
        </div>
        <div class="changeCompanyAndFiles">
          <a-row>
            <a-col :span="12">
              <div class="filesBtnGroup">
                <div class="uploadBtn">
                  <span>上传文件</span>
                  <a-upload
                    accept="xls/xlsx"
                    name="file"
                    :fileList="fileList"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                    @change="handleChange"
                  >
                    <a-button>上传</a-button>
                  </a-upload>
                </div>
                <div class="downloadBtn">
                  <span>模板下载</span>
                  <a-button
                    type="primary"
                    @click="downloadFile"
                    v-if="$auth(searchDept ? 'gasEquipmentLedger.downLoadModel' : 'centralizedManagement.downLoadModel')"
                  >下载</a-button>
                </div>
              </div>
            </a-col>
            <a-col :span="12">
              <span>所属公司</span>
              <a-tree-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model="subcompanyid"
                style="width: 200px;margin-left: 8px;"
                placeholder="请选择所属公司"
                allow-clear
                show-search
                :filterTreeNode="filterTreeNode"
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="companyList"
                :replaceFields="{
                  title: 'url',
                  key: 'id',
                  value: 'id'
                }"
                @change="(value, label, extra) => changeSubCompany(label[0], extra)"
              ></a-tree-select>
            </a-col>
          </a-row>
          <div class="attentionDiv" :style="{marginTop: fileList.length > 0 ? '40px' : '20px'}">
            <p>注意&emsp;1：上传文件时需要选择设备类型。</p>
            <p>2：上传文件格式必须是该设备类型下下载的模板。</p>
            <p>3：补充导入时必须在模板中填写设备编码【可以先导出获取设备编码，再填写到下载的模板里】。</p>
            <div v-show="importType === 2">
              <p>4：所属公司不为空时归口部门不能为空</p>
              <p>5：使用部门不为空时所属公司/归口部门不能为空</p>
              <p>6：使用人员不为空时所属公司/使用部门/归口部门不能为空</p>
              <p>7：归口部门不为空时所属公司/使用部门不能为空</p>
              <p>8：归口部门负责人不为空时所属公司/归口部门/使用部门不能为空</p>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
  </zm-drawer>
</template>

<script>
import {
  equipmentImport,
  equipmentTemplate,
  getEquipmentExport,
  getParamValuesByEquipmentTypeAndId
} from '@/api/equipmentLedger'
import ModuleBox from '@/views/assetLedger/modules/moduleBox.vue'
import { getDeviceTypeTree } from '@/api/deviceType'
import { getDeptTreeList } from '@/api/assetLedger'
import { mapGetters } from 'vuex'
import brandNewImport from '@/views/equipmentLedger/modules/importModal/brandNewImport'
import supplementaryImport from '@/views/equipmentLedger/modules/importModal/supplementaryImport'
export default {
  components: { ModuleBox },
  props: {
    // 气体设备用到的
    searchDept: {
      type: String,
      default: ''
    },
    // 气体设备用到的
    searchDeviceType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 抽屉是否显示
      visible: false,
      // 抽屉标题
      title: '导入',
      footer: true,
      okText: '导入',
      placement: 'right',
      loading: false,
      btnLoading: false,
      // 导出方式
      importType: 1,
      // 设备类型列表
      equipmentClassList: [],
      // 设备分类
      equipmentTypeImport: undefined,
      // 设备类型名称
      equipmentTypeName: '',
      // 所属公司列表
      companyList: [],
      // 所属公司
      subcompanyid: undefined,
      // 所属公司名称
      subcompanyName: '',
      checkBasicList: {
        name: '基本信息',
        indeterminate: null,
        checkAll: false,
        options: brandNewImport,
        disabledList: [],
        bcList: [],
        checkList: []
      },
      checkDeviceTypeList: [],
      // 上传文件列表
      fileList: []
    }
  },
  created () {
    this.getEquipmentClassList()
    // this.getCompanyList()
  },

  computed: {
    ...mapGetters(['centralizedManagementCompanyId', 'equipmentType'])
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      if (flag) {
        this.getCompanyList()
        const isCompany = this.centralizedManagementCompanyId.data.isCompany
        this.subcompanyid = isCompany ? this.centralizedManagementCompanyId.data.id : undefined
        this.changeSubCompany(isCompany ? this.centralizedManagementCompanyId.data.subcompanyname : '')
        if (this.equipmentType.equipmentType !== '' && this.equipmentType.equipmentType !== '设备分类' && this.equipmentType.equipmentType !== '空') {
          this.equipmentTypeImport = this.equipmentType.equipmentType
          this.changeEquipmentType(this.equipmentType.equipmentType, this.equipmentType.equipmentData.name)
        } else {
          this.equipmentTypeImport = undefined
        }
      }
      this.changeBasicCheckList()
      this.visible = flag
    },
    // 改变基础信息的checkList
    changeBasicCheckList () {
      const checkList = []
      for (const item of this.checkBasicList.options.children) {
        if (item.checked === true) {
          checkList.push(item.name)
        }
      }
      this.checkBasicList.checkList = this.checkBasicList.bcList.length > 0 && this.importType === 2 ? JSON.parse(JSON.stringify(this.checkBasicList.bcList)) : JSON.parse(JSON.stringify(checkList))
      this.checkBasicList.disabledList = checkList
      this.checkBasicList.bcList = this.checkBasicList.bcList.length > 0 ? this.checkBasicList.bcList : JSON.parse(JSON.stringify(checkList))
      if (checkList.length > 0) {
        if (this.checkBasicList.bcList.length === this.checkBasicList.options.children.length) {
          this.checkBasicList.checkAll = true
          this.checkBasicList.indeterminate = false
        } else {
          this.checkBasicList.checkAll = false
          this.checkBasicList.indeterminate = true
        }
      } else {
        this.checkBasicList.indeterminate = false
        this.checkBasicList.checkAll = false
      }
    },
    // 改变导入方式
    changeImportType (e) {
      if (e.target.value === 1) {
        this.checkBasicList.options = brandNewImport
      } else {
        this.checkBasicList.options = supplementaryImport
      }
      this.changeBasicCheckList()
    },
    // 获取设备类别
    getEquipmentClassList () {
      const data = {}
      if (this.searchDeviceType) {
        data.code = this.searchDeviceType
      }
      getDeviceTypeTree(data).then(res => {
        if (res.status === 0) {
          this.equipmentClassList = res.data
        }
      })
    },
    // 重置children数组
    resetTheChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length) {
            item.disabled = true
            item.children = self.resetTheChildrenArray(item.children)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取所属公司
    getCompanyList () {
      const data = {
        paging: false
      }
      if (this.centralizedManagementCompanyId.data.id) {
        data.id = this.centralizedManagementCompanyId.data.id === '杭氧' ? '' : this.centralizedManagementCompanyId.data.id
      } else {
        if (this.searchDept) {
          data.id = this.searchDept
        }
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            if (item.children.length > 0) {
              item.disabled = true
            }
            item.children = this.resetTheChildrenArray(item.children)
          })
          this.companyList = res.data
        }
      })
    },
    // 改变设备类型
    changeEquipmentType (value, label) {
      // 删除checkDeviceTypeList数组中除了下标是0的其他元素，重置
      this.checkDeviceTypeList = []
      this.equipmentTypeName = label
      const deviceTypeList = []
      const data = {
        equipmentType: value
      }
      this.loading = true
      getParamValuesByEquipmentTypeAndId(data).then(res => {
        if (res.status === 0) {
          for (const item of res.data) {
            const obj = {
              name: item.pName,
              indeterminate: null,
              checkAll: null,
              options: [],
              checkList: []
            }
            for (const childItem of item.children) {
              delete childItem.label
            }
            item.indeterminate = null
            item.basicIndeterminate = null
            item.checkAll = null
            item.basicCheckAll = false
            item.checkList = []
            item.basicCheckList = []
            // obj.options.push(item)
            deviceTypeList.push(item)
          }
          this.checkDeviceTypeList = deviceTypeList
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
        .catch(err => {
          this.loading = false
        })
    },
    // 改变公司名称
    changeSubCompany (label, extra) {
      if (label) {
        this.subcompanyName = extra ? extra.triggerNode.$options.propsData.dataRef.subcompanyname : label
      } else {
        this.subcompanyName = ''
      }
    },
    // 搜索设备类型
    filterTreeNode (inputValue, treeNode) {
      return treeNode.data.props.title.includes(inputValue)
    },
    // 固定模块字段选中
    fixedOnChange (listName, index, checkedList) {
      this[listName][index].indeterminate = !!checkedList.length && checkedList.length < this[listName][index].children.length
      this[listName][index].checkAll = checkedList.length === this[listName][index].children.length
      this.$forceUpdate()
    },
    // 固定模块字段全选
    fixedAllChange (listName, index, e) {
      const plainOptions = []
      this[listName][index].children.forEach(item => {
        plainOptions.push(item.value)
      })
      this[listName][index].checkList = e.target.checked ? plainOptions : []
      this[listName][index].checkAll = e.target.checked
      this[listName][index].indeterminate = false
      this.$forceUpdate()
    },
    // 基础信息单选框
    chagneBasicCheckBox (item, item2, e) {
      if (e.target.checked) {
        item.checkList.push(item2.name)
        item.bcList.push(item2.name)
        if (item2.name === '公司名称') {
          this.iterateOverAddFields(['归口部门'], item)
        } else if (item2.name === '使用部门') {
          this.iterateOverAddFields(['公司名称', '归口部门'], item)
        } else if (item2.name === '使用人员') {
          this.iterateOverAddFields(['公司名称', '归口部门', '使用部门'], item)
        } else if (item2.name === '归口部门') {
          this.iterateOverAddFields(['公司名称', '使用部门'], item)
        } else if (item2.name === '归口部门负责人') {
          this.iterateOverAddFields(['公司名称', '归口部门', '使用部门'], item)
        }
      } else {
        const index = item.checkList.indexOf(item2.name)
        item.checkList.splice(index, 1)
        item.bcList.splice(index, 1)
        if (item2.name === '公司名称') {
          this.iterateOverDelFields(['使用部门', '使用人员', '归口部门', '归口部门负责人'], item)
        } else if (item2.name === '使用部门') {
          this.iterateOverDelFields(['公司名称', '使用人员', '归口部门', '归口部门负责人'], item)
        } else if (item2.name === '归口部门') {
          this.iterateOverDelFields(['公司名称', '使用部门', '使用人员', '归口部门负责人'], item)
        }
      }
      item.checkAll = item.checkList.length === item.options.children.length
      item.indeterminate = !!item.checkList.length && item.checkList.length < item.options.children.length
      this.$forceUpdate()
    },
    // 遍历是否需要添加字段
    iterateOverAddFields (fieldList, item) {
      for (const field of fieldList) {
        if (item.checkList.indexOf(listItem => listItem === field) === -1) {
          // 没有归口部门
          item.checkList.push(field)
          item.bcList.push(field)
          const checkList = JSON.parse(JSON.stringify(item.checkList))
          const bcList = JSON.parse(JSON.stringify(item.bcList))
          item.checkList = this.deleteRepetition(checkList)
          item.bcList = this.deleteRepetition(bcList)
        }
      }
    },
    // 遍历是否需要添加字段
    iterateOverDelFields (fieldList, item) {
      for (const field of fieldList) {
        const index = item.checkList.indexOf(field)
        if (index > -1) {
          item.checkList.splice(index, 1)
          item.bcList.splice(index, 1)
        }
        item.checkList = this.deleteRepetition(item.checkList)
        item.bcList = this.deleteRepetition(item.bcList)
      }
    },
    // 去重
    deleteRepetition (arr) {
      const newArr = []
      for (const item of arr) {
        if (newArr.indexOf(item) === -1) {
          newArr.push(item)
        }
      }
      return newArr
    },
    // 基础信息全选
    changeAll (item, e) {
      item.checkAll = e.target.checked
      item.indeterminate = false
      if (e.target.checked) {
        const checkList = []
        item.options.children.forEach(item2 => {
          checkList.push(item2.name)
        })
        item.checkList = JSON.parse(JSON.stringify(checkList))
        item.bcList = JSON.parse(JSON.stringify(checkList))
      } else {
        item.checkList = JSON.parse(JSON.stringify(item.disabledList))
        item.bcList = JSON.parse(JSON.stringify(item.disabledList))
        if (item.disabledList.length > 0) {
          item.indeterminate = true
        }
      }
      this.$forceUpdate()
    },
    // 模板下载
    downloadFile () {
      if (!this.equipmentTypeImport) {
        this.$message.error('请选择设备类型')
        return
      }
      let strExcelTempHead = []
      const basicCheckList = JSON.parse(JSON.stringify(this.checkBasicList))
      if (this.importType === 1) {
        // 全新导入
        basicCheckList.options.children.forEach(item => {
          if (item.name === '公司名称' && this.subcompanyName !== '') {
            item.valueType = 2
            item.valueOptions = this.subcompanyName
          }
          if (item.name === '设备分类') {
            item.valueOptions = this.equipmentTypeName
          }
        })
        strExcelTempHead = [basicCheckList.options]
        for (const item of this.checkDeviceTypeList) {
          strExcelTempHead.push(item)
        }
      } else {
        const baSicList = []
        for (const item of basicCheckList.options.children) {
          if (basicCheckList.checkList.indexOf(item.name) > -1) {
            if (item.name === '公司名称' && this.subcompanyName !== '') {
              item.valueType = 2
              item.valueOptions = this.subcompanyName
            }
            if (item.name === '设备分类') {
              item.valueOptions = this.equipmentTypeName
            }
            baSicList.push(item)
          }
        }
        strExcelTempHead.push({
          ...basicCheckList.options,
          children: baSicList
        })
        for (const item of this.checkDeviceTypeList) {
          const childrenList = []
          for (const childItem of item.children) {
            if (item.checkList.indexOf(childItem.value) > -1) {
              childrenList.push(childItem)
            }
          }
          if (childrenList.length > 0) {
            strExcelTempHead.push({
              ...item,
              children: childrenList
            })
          }
        }
      }
      const data = {
        equipmentType: this.equipmentTypeImport,
        equipmentTypeName: this.equipmentTypeName,
        excelTempHead: strExcelTempHead
      }
      equipmentTemplate(data).then((res) => {
        const fileNameType = this.importType === 1 ? '全新' : '补充'
        var filename = this.equipmentTypeName + fileNameType + '导入模板'
        const url = window.URL.createObjectURL(res)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', filename + '.xls')
        document.body.appendChild(link)
        link.click()
      })
    },
    // 文件移除
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    // 上传前
    beforeUpload (file) {
      var fileName = file.name.split('.')
      var type = fileName[fileName.length - 1]

      // if (type === 'xls' || type === 'xlsx') {
      //   this.fileList = [file]
      // } else {
      //   this.$message.error('只支持xls、xlsx格式的文件')
      // }
      // return false
      return new Promise((resolve, reject) => {
        if (type === 'xls' || type === 'xlsx') {
          this.fileList = [file]
          return false
        } else {
          this.fileList = []
          this.$message.error('只支持xls、xlsx格式的文件')
          reject(file)
        }
      })
    },
    // 上传文件改变
    handleChange (info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })
      this.fileList = fileList
    },
    // 导入
    submitForm () {
      if (!this.equipmentTypeImport) {
        this.$message.error('请选择设备类型')
        return
      }
      const { fileList } = this
      const formData = new FormData()
      fileList.forEach((file) => {
        formData.append('file', file)
        formData.append('equipmentType', this.equipmentTypeImport)
        formData.append('equipmentTypeName', this.equipmentTypeName)
        formData.append('subcompanyid', this.subcompanyid)
        formData.append('importType', this.importType)
      })
      this.$refs.zmDrawer.handleOkLoading(true)
      equipmentImport(formData)
        .then((res) => {
          if (res.status === 0) {
            this.fileList = []
            this.$message.success('导入成功！')
            this.$refs.zmDrawer.handleOkLoading(false)
            this.$emit('getTableData')
            this.cancel()
          } else {
            const message = res.info.message.split(';')
            this.$notification.error({
              message: '导入失败',
              description: (h) => {
                const tipDom = []
                message.map((item) => {
                  tipDom.push(h('span', item))
                  tipDom.push(h('br'))
                })
                return h('span', tipDom)
              },
              style: {
                width: '500px',
                marginLeft: `-110px`
              },
              duration: 0
            })
            this.$refs.zmDrawer.handleOkLoading(false)
          }
        })
        .catch((error) => {
          this.$refs.zmDrawer.handleOkLoading(false)
        })
    },
    // 关闭抽屉
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 重置
    formClear () {
      this.$nextTick(() => {
        this.loading = false
        this.btnLoading = false
        this.checkBasicList = {
          name: '基本信息',
          indeterminate: null,
          checkAll: false,
          options: brandNewImport,
          disabledList: [],
          bcList: [],
          checkList: []
        }
        this.checkDeviceTypeList = []
        this.fileList = []
        this.equipmentTypeImport = undefined
        this.equipmentTypeName = undefined
        this.subcompanyid = undefined
        this.importType = 1
      })
    }
  }
}
</script>
<style lang="less">
.derivedModeImport {
  padding-bottom: 16px;
  .radioCol {
    display: flex;
    align-items: center;
    height: 32px;
  }
  .derivedModeRadio {
    margin-left: 12px;
    display: flex;
    .ant-radio-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
.checkDisable {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: #0000004C;
  z-index: 2;
  cursor: not-allowed;
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 10px;
  .titleName{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: rgba(8, 64, 159, 1);
    margin-right: 12px;
  }
  .addModelListIcon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
.modelTitleDiv {
  width: 100%;
  padding-top: 9px;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
  border-bottom: 1px solid rgba(241, 241, 241, 1);
}
.checkModelBox {
  border-bottom: 1px solid rgba(241, 241, 241, 1);
  padding-top: 9px;
  .checkBoxGroup {
    display: grid;
    grid-template-columns: repeat(5, calc((100% - 100px )/ 5));
    grid-column-gap: 28px;
    .importCheckBox {
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .ellipsis {
        display: inline-block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 2px;
      }
    }
    //grid-row-gap: 16px;
    .ant-checkbox-group-item {
      margin-bottom: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .ellipsis {
        display: inline-block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 2px;
      }
    }
    .ant-checkbox-group-item >span:nth-child(2) {
      width: calc(100% - 12px);
    }
  }
}
.checkDeviceTypeBox:nth-child(1) {
  border-top: 1px solid rgba(241, 241, 241, 1);
}
.changeCompanyAndFiles {
  margin-top: 8px;
  .filesBtnGroup {
    display: flex;
    align-items: center;
    .downloadBtn, .uploadBtn {
      >span {
        margin-right: 8px;
      }
    }
    .downloadBtn {
      margin-left: 30px;
      width: 125px;
    }
    .uploadBtn {
      width: 125px;
      position: relative;
      .ant-upload-list {
        position: absolute;
        .ant-upload-list-item-name {
          padding-right: 15px;
        }
      }
    }
  }
  .attentionDiv {
    color: rgba(231, 59, 59, 1);
    //margin-top: 20px;
    p {
      margin: 0;
      padding-left: 3em;
    }
    >p:nth-child(1) {
      padding-left: 0;
    }
  }
}
.spanRequired:before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 12px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}
.ant-checkbox + span{
  padding-left: 4px;
  width: calc(100% - 15px);
}
.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner::after {
  left: 20% !important;
}
.ant-checkbox-wrapper .ant-checkbox-indeterminate .ant-checkbox-inner::after {
  top: 46% !important;
}
.ant-upload-list-item-info > span {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
